import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import { withStyles } from '@material-ui/core/styles';
import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Checkbox,
  Divider,
  Button,
  Link,
  Table,
  TableBody,
  TableCell,
  TablePagination,
  TableRow,
  Typography
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 700
  },
  nameCell: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    height: 42,
    width: 42,
    marginRight: theme.spacing(1)
  },
  actions: {
    padding: theme.spacing(1),
    justifyContent: 'flex-end'
  },
}));

const Results = props => {
  const { className, corrections, title, ...rest } = props;

  const classes = useStyles();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, page) => {
    setPage(page);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(event.target.value);
  };

  function handleBackButtonClick(event) {
    handleChangePage(event, page - 1);  
  }

  function handleNextButtonClick(event) {
    handleChangePage(event, page + 1);  
  }

  const StyledPagination = withStyles({
    actions: {
      marginLeft: 4,
    },
    selectRoot: {
      marginRight: 16,
      marginLeft: 4
    }
  })(TablePagination);

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Typography
        color="textSecondary"
        gutterBottom
        variant="body2"
      >
        {corrections.length} مورد یافت شد. صفحه {page + 1} از{' '}
        {Math.ceil(corrections.length / rowsPerPage)}
      </Typography>
      <Card>
        <CardHeader
          title={title}
        />
        <Divider />
        <CardContent className={classes.content}>
          <PerfectScrollbar>
            <div className={classes.inner}>
              <Table className={classes.table}>
                <TableBody>
                  {corrections.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(correction => (
                    <TableRow
                      hover
                      key={correction.id}
                    >
                      <TableCell>
                        <div className={classes.nameCell}>
                          <div>
                            <Link
                              color="inherit"
                              component={RouterLink}
                              to={`/corrections/${correction.id}` }
                              variant="h6"
                            >
                              {correction.question.exam.exam_number == '1' ? 'میان‌ترم' : 'پایان‌ترم'} {correction.question.exam.courses[0].name}- سوال {correction.question.number}
                            </Link>
                          </div>
                        </div>
                      </TableCell>
                      <TableCell align="right">
                        <Button
                          color="primary"
                          component={RouterLink}
                          size="small"
                          to={`/corrections/${correction.id}` }
                          variant="outlined"
                        >
                          تصحیح
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </PerfectScrollbar>
        </CardContent>
        <CardActions className={classes.actions}>
        <StyledPagination
            classes={{
              actions: {
                marginLeft: 4,
              },
              selectRoot: {
                marginRight: 16,
                marginLeft: 4
              }
            }}
            component="div"
            count={corrections.length}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            page={page}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
            labelRowsPerPage={"تعداد در صفحه"}
            labelDisplayedRows={({ from, to, count }) => `${from}-${to} از ${count}`}
            nextIconButtonProps={{onClick: handleNextButtonClick}}
          />
        </CardActions>
      </Card>
    </div>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  corrections: PropTypes.array.isRequired
};

Results.defaultProps = {
  corrections: []
};

export default Results;
